<!-- range-picker.component.html -->
<form>
  <div class="form-group">
    <input type="text" class="form-control" placeholder="Select Dates" bsDaterangepicker [daysDisabled]="[2, 3, 4, 5, 6]"
      [bsConfig]="bsConfig" [(ngModel)]="dateRange" (bsValueChange)="onValueChange($event)">
  </div>
</form>
